"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedTeamChatServiceServer = exports.ProtectedTeamChatServiceDispatcher = exports.ProtectedTeamChatServiceClient = void 0;
var irt_1 = require("@playq/irt");
var ThreadMessagePage_1 = require("./ThreadMessagePage");
var TeamIdWithTemplateId_1 = require("./TeamIdWithTemplateId");
var ThreadMessagePointer_1 = require("./ThreadMessagePointer");
var SendMessage_1 = require("./SendMessage");
var CustomChannel_1 = require("./CustomChannel");
var MessageThread_1 = require("./MessageThread");
var MessagePage_1 = require("./MessagePage");
var MessageThreadBatch_1 = require("./MessageThreadBatch");
var MessagePointer_1 = require("./MessagePointer");
var TeamStatusError_1 = require("./TeamStatusError");
var MessageSender_1 = require("./MessageSender");
var MessageReceiver_1 = require("./MessageReceiver");
var MessageUpdatesPage_1 = require("./MessageUpdatesPage");
var services_shared_1 = require("@playq/services-shared");
var MessageData_1 = require("./MessageData");
var AvailableChannels_1 = require("./AvailableChannels");
var irt_2 = require("@playq/irt");
var InSendMessage = (function () {
    function InSendMessage(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.message = new SendMessage_1.SendMessage(data.message);
    }
    Object.defineProperty(InSendMessage.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field message is not optional');
            }
            this._message = value;
        },
        enumerable: false,
        configurable: true
    });
    InSendMessage.prototype.serialize = function () {
        return {
            message: this.message.serialize()
        };
    };
    return InSendMessage;
}());
var OutSendMessageHelpers = (function () {
    function OutSendMessageHelpers() {
    }
    OutSendMessageHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutSendMessageHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new MessagePointer_1.MessagePointer(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSendMessageHelpers;
}());
var InSendMessageFrom = (function () {
    function InSendMessageFrom(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.message = new SendMessage_1.SendMessage(data.message);
        this.sender = MessageSender_1.MessageSenderHelpers.deserialize(data.sender);
    }
    Object.defineProperty(InSendMessageFrom.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field message is not optional');
            }
            this._message = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSendMessageFrom.prototype, "sender", {
        get: function () {
            return this._sender;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sender is not optional');
            }
            this._sender = value;
        },
        enumerable: false,
        configurable: true
    });
    InSendMessageFrom.prototype.serialize = function () {
        return {
            message: this.message.serialize(),
            sender: MessageSender_1.MessageSenderHelpers.serialize(this.sender)
        };
    };
    return InSendMessageFrom;
}());
var OutSendMessageFromHelpers = (function () {
    function OutSendMessageFromHelpers() {
    }
    OutSendMessageFromHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutSendMessageFromHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new MessagePointer_1.MessagePointer(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSendMessageFromHelpers;
}());
var InReadMessages = (function () {
    function InReadMessages(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.receiver = MessageReceiver_1.MessageReceiverHelpers.deserialize(data.receiver);
        this.timeOffsetIterator = new services_shared_1.TimeOffsetIterator(data.timeOffsetIterator);
        this.withThreads = data.withThreads;
    }
    Object.defineProperty(InReadMessages.prototype, "receiver", {
        get: function () {
            return this._receiver;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field receiver is not optional');
            }
            this._receiver = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InReadMessages.prototype, "timeOffsetIterator", {
        get: function () {
            return this._timeOffsetIterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field timeOffsetIterator is not optional');
            }
            this._timeOffsetIterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InReadMessages.prototype, "withThreads", {
        get: function () {
            return this._withThreads;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field withThreads is not optional');
            }
            if (typeof value !== 'boolean') {
                throw new Error('Field withThreads expects boolean type, got ' + value);
            }
            this._withThreads = value;
        },
        enumerable: false,
        configurable: true
    });
    InReadMessages.prototype.serialize = function () {
        return {
            receiver: MessageReceiver_1.MessageReceiverHelpers.serialize(this.receiver),
            timeOffsetIterator: this.timeOffsetIterator.serialize(),
            withThreads: this.withThreads
        };
    };
    return InReadMessages;
}());
var OutReadMessagesHelpers = (function () {
    function OutReadMessagesHelpers() {
    }
    OutReadMessagesHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutReadMessagesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new MessagePage_1.MessagePage(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutReadMessagesHelpers;
}());
var InReadMessageUpdates = (function () {
    function InReadMessageUpdates(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.receiver = MessageReceiver_1.MessageReceiverHelpers.deserialize(data.receiver);
        this.timeOffsetIterator = new services_shared_1.TimeOffsetIterator(data.timeOffsetIterator);
    }
    Object.defineProperty(InReadMessageUpdates.prototype, "receiver", {
        get: function () {
            return this._receiver;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field receiver is not optional');
            }
            this._receiver = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InReadMessageUpdates.prototype, "timeOffsetIterator", {
        get: function () {
            return this._timeOffsetIterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field timeOffsetIterator is not optional');
            }
            this._timeOffsetIterator = value;
        },
        enumerable: false,
        configurable: true
    });
    InReadMessageUpdates.prototype.serialize = function () {
        return {
            receiver: MessageReceiver_1.MessageReceiverHelpers.serialize(this.receiver),
            timeOffsetIterator: this.timeOffsetIterator.serialize()
        };
    };
    return InReadMessageUpdates;
}());
var OutReadMessageUpdatesHelpers = (function () {
    function OutReadMessageUpdatesHelpers() {
    }
    OutReadMessageUpdatesHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutReadMessageUpdatesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new MessageUpdatesPage_1.MessageUpdatesPage(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutReadMessageUpdatesHelpers;
}());
var InDeleteMessage = (function () {
    function InDeleteMessage(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.message = new MessagePointer_1.MessagePointer(data.message);
    }
    Object.defineProperty(InDeleteMessage.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field message is not optional');
            }
            this._message = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteMessage.prototype.serialize = function () {
        return {
            message: this.message.serialize()
        };
    };
    return InDeleteMessage;
}());
var OutDeleteMessageHelpers = (function () {
    function OutDeleteMessageHelpers() {
    }
    OutDeleteMessageHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutDeleteMessageHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteMessageHelpers;
}());
var InDeleteMessages = (function () {
    function InDeleteMessages(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.receiver = MessageReceiver_1.MessageReceiverHelpers.deserialize(data.receiver);
        this.from_AsString = typeof data.from !== 'undefined' ? data.from : undefined;
        this.tillAsString = typeof data.till !== 'undefined' ? data.till : undefined;
    }
    Object.defineProperty(InDeleteMessages.prototype, "receiver", {
        get: function () {
            return this._receiver;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field receiver is not optional');
            }
            this._receiver = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteMessages.prototype, "from_", {
        get: function () {
            return this._from;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._from = undefined;
                return;
            }
            if (!(value instanceof Date)) {
                throw new Error('Field from_ expects type Date, got ' + value);
            }
            this._from = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteMessages.prototype, "from_AsString", {
        get: function () {
            if (!this._from) {
                return undefined;
            }
            return irt_1.Formatter.writeZoneDateTime(this._from);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                this._from = undefined;
                return;
            }
            this._from = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteMessages.prototype, "till", {
        get: function () {
            return this._till;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._till = undefined;
                return;
            }
            if (!(value instanceof Date)) {
                throw new Error('Field till expects type Date, got ' + value);
            }
            this._till = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteMessages.prototype, "tillAsString", {
        get: function () {
            if (!this._till) {
                return undefined;
            }
            return irt_1.Formatter.writeZoneDateTime(this._till);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                this._till = undefined;
                return;
            }
            this._till = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    InDeleteMessages.prototype.serialize = function () {
        return {
            receiver: MessageReceiver_1.MessageReceiverHelpers.serialize(this.receiver),
            from: typeof this.from_ !== 'undefined' ? this.from_AsString : undefined,
            till: typeof this.till !== 'undefined' ? this.tillAsString : undefined
        };
    };
    return InDeleteMessages;
}());
var OutDeleteMessagesHelpers = (function () {
    function OutDeleteMessagesHelpers() {
    }
    OutDeleteMessagesHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutDeleteMessagesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteMessagesHelpers;
}());
var InSendToThread = (function () {
    function InSendToThread(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.parent = new MessagePointer_1.MessagePointer(data.parent);
        this.msgData = MessageData_1.MessageDataHelpers.deserialize(data.msgData);
    }
    Object.defineProperty(InSendToThread.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field parent is not optional');
            }
            this._parent = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSendToThread.prototype, "msgData", {
        get: function () {
            return this._msgData;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field msgData is not optional');
            }
            this._msgData = value;
        },
        enumerable: false,
        configurable: true
    });
    InSendToThread.prototype.serialize = function () {
        return {
            parent: this.parent.serialize(),
            msgData: MessageData_1.MessageDataHelpers.serialize(this.msgData)
        };
    };
    return InSendToThread;
}());
var OutSendToThreadHelpers = (function () {
    function OutSendToThreadHelpers() {
    }
    OutSendToThreadHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutSendToThreadHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new ThreadMessagePointer_1.ThreadMessagePointer(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSendToThreadHelpers;
}());
var InSendToThreadFrom = (function () {
    function InSendToThreadFrom(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.parent = new MessagePointer_1.MessagePointer(data.parent);
        this.msgData = MessageData_1.MessageDataHelpers.deserialize(data.msgData);
        this.sender = MessageSender_1.MessageSenderHelpers.deserialize(data.sender);
    }
    Object.defineProperty(InSendToThreadFrom.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field parent is not optional');
            }
            this._parent = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSendToThreadFrom.prototype, "msgData", {
        get: function () {
            return this._msgData;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field msgData is not optional');
            }
            this._msgData = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InSendToThreadFrom.prototype, "sender", {
        get: function () {
            return this._sender;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sender is not optional');
            }
            this._sender = value;
        },
        enumerable: false,
        configurable: true
    });
    InSendToThreadFrom.prototype.serialize = function () {
        return {
            parent: this.parent.serialize(),
            msgData: MessageData_1.MessageDataHelpers.serialize(this.msgData),
            sender: MessageSender_1.MessageSenderHelpers.serialize(this.sender)
        };
    };
    return InSendToThreadFrom;
}());
var OutSendToThreadFromHelpers = (function () {
    function OutSendToThreadFromHelpers() {
    }
    OutSendToThreadFromHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutSendToThreadFromHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new ThreadMessagePointer_1.ThreadMessagePointer(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutSendToThreadFromHelpers;
}());
var InReadThread = (function () {
    function InReadThread(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.parent = new MessagePointer_1.MessagePointer(data.parent);
    }
    Object.defineProperty(InReadThread.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field parent is not optional');
            }
            this._parent = value;
        },
        enumerable: false,
        configurable: true
    });
    InReadThread.prototype.serialize = function () {
        return {
            parent: this.parent.serialize()
        };
    };
    return InReadThread;
}());
var OutReadThreadHelpers = (function () {
    function OutReadThreadHelpers() {
    }
    OutReadThreadHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutReadThreadHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new MessageThread_1.MessageThread(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutReadThreadHelpers;
}());
var InReadThreadBatch = (function () {
    function InReadThreadBatch(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.parents = data.parents.map(function (e) { return new MessagePointer_1.MessagePointer(e); });
    }
    Object.defineProperty(InReadThreadBatch.prototype, "parents", {
        get: function () {
            return this._parents;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field parents is not optional');
            }
            this._parents = value;
        },
        enumerable: false,
        configurable: true
    });
    InReadThreadBatch.prototype.serialize = function () {
        return {
            parents: this.parents.map(function (e) { return e.serialize(); })
        };
    };
    return InReadThreadBatch;
}());
var OutReadThreadBatchHelpers = (function () {
    function OutReadThreadBatchHelpers() {
    }
    OutReadThreadBatchHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutReadThreadBatchHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new MessageThreadBatch_1.MessageThreadBatch(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutReadThreadBatchHelpers;
}());
var InReadThreadMessages = (function () {
    function InReadThreadMessages(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.receiver = MessageReceiver_1.MessageReceiverHelpers.deserialize(data.receiver);
        this.timeOffsetIterator = new services_shared_1.TimeOffsetIterator(data.timeOffsetIterator);
    }
    Object.defineProperty(InReadThreadMessages.prototype, "receiver", {
        get: function () {
            return this._receiver;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field receiver is not optional');
            }
            this._receiver = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InReadThreadMessages.prototype, "timeOffsetIterator", {
        get: function () {
            return this._timeOffsetIterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field timeOffsetIterator is not optional');
            }
            this._timeOffsetIterator = value;
        },
        enumerable: false,
        configurable: true
    });
    InReadThreadMessages.prototype.serialize = function () {
        return {
            receiver: MessageReceiver_1.MessageReceiverHelpers.serialize(this.receiver),
            timeOffsetIterator: this.timeOffsetIterator.serialize()
        };
    };
    return InReadThreadMessages;
}());
var OutReadThreadMessagesHelpers = (function () {
    function OutReadThreadMessagesHelpers() {
    }
    OutReadThreadMessagesHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutReadThreadMessagesHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new ThreadMessagePage_1.ThreadMessagePage(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutReadThreadMessagesHelpers;
}());
var InDeleteThreadMessage = (function () {
    function InDeleteThreadMessage(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.parent = new MessagePointer_1.MessagePointer(data.parent);
        this.sender = MessageSender_1.MessageSenderHelpers.deserialize(data.sender);
        this.messageId = data.messageId;
    }
    Object.defineProperty(InDeleteThreadMessage.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field parent is not optional');
            }
            this._parent = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteThreadMessage.prototype, "sender", {
        get: function () {
            return this._sender;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sender is not optional');
            }
            this._sender = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteThreadMessage.prototype, "messageId", {
        get: function () {
            return this._messageId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field messageId is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field messageId expects type string, got ' + value);
            }
            if (!value.match('^[0-9a-fA-f]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')) {
                throw new Error('Field messageId expects guid format, got ' + value);
            }
            this._messageId = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteThreadMessage.prototype.serialize = function () {
        return {
            parent: this.parent.serialize(),
            sender: MessageSender_1.MessageSenderHelpers.serialize(this.sender),
            messageId: this.messageId
        };
    };
    return InDeleteThreadMessage;
}());
var OutDeleteThreadMessageHelpers = (function () {
    function OutDeleteThreadMessageHelpers() {
    }
    OutDeleteThreadMessageHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutDeleteThreadMessageHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteThreadMessageHelpers;
}());
var InAvailableChannels = (function () {
    function InAvailableChannels(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.teamId = new TeamIdWithTemplateId_1.TeamIdWithTemplateId(data.teamId);
    }
    Object.defineProperty(InAvailableChannels.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    InAvailableChannels.prototype.serialize = function () {
        return {
            teamId: this.teamId.serialize()
        };
    };
    return InAvailableChannels;
}());
var OutAvailableChannelsHelpers = (function () {
    function OutAvailableChannelsHelpers() {
    }
    OutAvailableChannelsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutAvailableChannelsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new AvailableChannels_1.AvailableChannels(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutAvailableChannelsHelpers;
}());
var InCreateChannel = (function () {
    function InCreateChannel(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.teamId = new TeamIdWithTemplateId_1.TeamIdWithTemplateId(data.teamId);
        this.teamChannel = new CustomChannel_1.CustomChannel(data.teamChannel);
    }
    Object.defineProperty(InCreateChannel.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InCreateChannel.prototype, "teamChannel", {
        get: function () {
            return this._teamChannel;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamChannel is not optional');
            }
            this._teamChannel = value;
        },
        enumerable: false,
        configurable: true
    });
    InCreateChannel.prototype.serialize = function () {
        return {
            teamId: this.teamId.serialize(),
            teamChannel: this.teamChannel.serialize()
        };
    };
    return InCreateChannel;
}());
var OutCreateChannelHelpers = (function () {
    function OutCreateChannelHelpers() {
    }
    OutCreateChannelHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutCreateChannelHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCreateChannelHelpers;
}());
var InDeleteChannel = (function () {
    function InDeleteChannel(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.teamId = new TeamIdWithTemplateId_1.TeamIdWithTemplateId(data.teamId);
        this.teamChannel = new CustomChannel_1.CustomChannel(data.teamChannel);
    }
    Object.defineProperty(InDeleteChannel.prototype, "teamId", {
        get: function () {
            return this._teamId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamId is not optional');
            }
            this._teamId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteChannel.prototype, "teamChannel", {
        get: function () {
            return this._teamChannel;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field teamChannel is not optional');
            }
            this._teamChannel = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteChannel.prototype.serialize = function () {
        return {
            teamId: this.teamId.serialize(),
            teamChannel: this.teamChannel.serialize()
        };
    };
    return InDeleteChannel;
}());
var OutDeleteChannelHelpers = (function () {
    function OutDeleteChannelHelpers() {
    }
    OutDeleteChannelHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutDeleteChannelHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteChannelHelpers;
}());
var InPinMessage = (function () {
    function InPinMessage(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.message = new MessagePointer_1.MessagePointer(data.message);
    }
    Object.defineProperty(InPinMessage.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field message is not optional');
            }
            this._message = value;
        },
        enumerable: false,
        configurable: true
    });
    InPinMessage.prototype.serialize = function () {
        return {
            message: this.message.serialize()
        };
    };
    return InPinMessage;
}());
var OutPinMessageHelpers = (function () {
    function OutPinMessageHelpers() {
    }
    OutPinMessageHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutPinMessageHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutPinMessageHelpers;
}());
var InUnpinMessage = (function () {
    function InUnpinMessage(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.message = new MessagePointer_1.MessagePointer(data.message);
    }
    Object.defineProperty(InUnpinMessage.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field message is not optional');
            }
            this._message = value;
        },
        enumerable: false,
        configurable: true
    });
    InUnpinMessage.prototype.serialize = function () {
        return {
            message: this.message.serialize()
        };
    };
    return InUnpinMessage;
}());
var OutUnpinMessageHelpers = (function () {
    function OutUnpinMessageHelpers() {
    }
    OutUnpinMessageHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': TeamStatusError_1.TeamStatusErrorHelpers.serialize(either.value)
        };
    };
    OutUnpinMessageHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_2.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_2.Left(TeamStatusError_1.TeamStatusErrorHelpers.deserialize(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUnpinMessageHelpers;
}());
var ProtectedTeamChatServiceClient = (function () {
    function ProtectedTeamChatServiceClient(transport) {
        this._transport = transport;
    }
    ProtectedTeamChatServiceClient.prototype.getPackageName = function () { return ProtectedTeamChatServiceClient.PackageName; };
    ProtectedTeamChatServiceClient.prototype.getClassName = function () { return ProtectedTeamChatServiceClient.ClassName; };
    ProtectedTeamChatServiceClient.prototype.getFullClassName = function () { return ProtectedTeamChatServiceClient.FullClassName; };
    ProtectedTeamChatServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.sendMessage = function (message) {
        var _this = this;
        var __data = new InSendMessage();
        __data.message = message;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'sendMessage', __data)
                .then(function (data) {
                try {
                    resolve(OutSendMessageHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.sendMessageFrom = function (message, sender) {
        var _this = this;
        var __data = new InSendMessageFrom();
        __data.message = message;
        __data.sender = sender;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'sendMessageFrom', __data)
                .then(function (data) {
                try {
                    resolve(OutSendMessageFromHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.readMessages = function (receiver, timeOffsetIterator, withThreads) {
        var _this = this;
        var __data = new InReadMessages();
        __data.receiver = receiver;
        __data.timeOffsetIterator = timeOffsetIterator;
        __data.withThreads = withThreads;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'readMessages', __data)
                .then(function (data) {
                try {
                    resolve(OutReadMessagesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.readMessageUpdates = function (receiver, timeOffsetIterator) {
        var _this = this;
        var __data = new InReadMessageUpdates();
        __data.receiver = receiver;
        __data.timeOffsetIterator = timeOffsetIterator;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'readMessageUpdates', __data)
                .then(function (data) {
                try {
                    resolve(OutReadMessageUpdatesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.deleteMessage = function (message) {
        var _this = this;
        var __data = new InDeleteMessage();
        __data.message = message;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'deleteMessage', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteMessageHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.deleteMessages = function (receiver, from_, till) {
        var _this = this;
        var __data = new InDeleteMessages();
        __data.receiver = receiver;
        __data.from_ = from_;
        __data.till = till;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'deleteMessages', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteMessagesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.sendToThread = function (parent, msgData) {
        var _this = this;
        var __data = new InSendToThread();
        __data.parent = parent;
        __data.msgData = msgData;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'sendToThread', __data)
                .then(function (data) {
                try {
                    resolve(OutSendToThreadHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.sendToThreadFrom = function (parent, msgData, sender) {
        var _this = this;
        var __data = new InSendToThreadFrom();
        __data.parent = parent;
        __data.msgData = msgData;
        __data.sender = sender;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'sendToThreadFrom', __data)
                .then(function (data) {
                try {
                    resolve(OutSendToThreadFromHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.readThread = function (parent) {
        var _this = this;
        var __data = new InReadThread();
        __data.parent = parent;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'readThread', __data)
                .then(function (data) {
                try {
                    resolve(OutReadThreadHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.readThreadBatch = function (parents) {
        var _this = this;
        var __data = new InReadThreadBatch();
        __data.parents = parents;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'readThreadBatch', __data)
                .then(function (data) {
                try {
                    resolve(OutReadThreadBatchHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.readThreadMessages = function (receiver, timeOffsetIterator) {
        var _this = this;
        var __data = new InReadThreadMessages();
        __data.receiver = receiver;
        __data.timeOffsetIterator = timeOffsetIterator;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'readThreadMessages', __data)
                .then(function (data) {
                try {
                    resolve(OutReadThreadMessagesHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.deleteThreadMessage = function (parent, sender, messageId) {
        var _this = this;
        var __data = new InDeleteThreadMessage();
        __data.parent = parent;
        __data.sender = sender;
        __data.messageId = messageId;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'deleteThreadMessage', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteThreadMessageHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.availableChannels = function (teamId) {
        var _this = this;
        var __data = new InAvailableChannels();
        __data.teamId = teamId;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'availableChannels', __data)
                .then(function (data) {
                try {
                    resolve(OutAvailableChannelsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.createChannel = function (teamId, teamChannel) {
        var _this = this;
        var __data = new InCreateChannel();
        __data.teamId = teamId;
        __data.teamChannel = teamChannel;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'createChannel', __data)
                .then(function (data) {
                try {
                    resolve(OutCreateChannelHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.deleteChannel = function (teamId, teamChannel) {
        var _this = this;
        var __data = new InDeleteChannel();
        __data.teamId = teamId;
        __data.teamChannel = teamChannel;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'deleteChannel', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteChannelHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.pinMessage = function (message) {
        var _this = this;
        var __data = new InPinMessage();
        __data.message = message;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'pinMessage', __data)
                .then(function (data) {
                try {
                    resolve(OutPinMessageHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.prototype.unpinMessage = function (message) {
        var _this = this;
        var __data = new InUnpinMessage();
        __data.message = message;
        return new Promise(function (resolve, reject) {
            _this._transport.send(ProtectedTeamChatServiceClient.ClassName, 'unpinMessage', __data)
                .then(function (data) {
                try {
                    resolve(OutUnpinMessageHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    ProtectedTeamChatServiceClient.PackageName = 'net.playq.services.teams';
    ProtectedTeamChatServiceClient.ClassName = 'ProtectedTeamChatService';
    ProtectedTeamChatServiceClient.FullClassName = 'net.playq.services.teams.ProtectedTeamChatService';
    return ProtectedTeamChatServiceClient;
}());
exports.ProtectedTeamChatServiceClient = ProtectedTeamChatServiceClient;
var ProtectedTeamChatServiceDispatcher = (function () {
    function ProtectedTeamChatServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    ProtectedTeamChatServiceDispatcher.prototype.getSupportedService = function () {
        return 'ProtectedTeamChatService';
    };
    ProtectedTeamChatServiceDispatcher.prototype.getSupportedMethods = function () {
        return ProtectedTeamChatServiceDispatcher.methods;
    };
    ProtectedTeamChatServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "sendMessage": {
                var obj_1 = new InSendMessage(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.sendMessage(context, obj_1.message)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSendMessageHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "sendMessageFrom": {
                var obj_2 = new InSendMessageFrom(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.sendMessageFrom(context, obj_2.message, obj_2.sender)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSendMessageFromHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "readMessages": {
                var obj_3 = new InReadMessages(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.readMessages(context, obj_3.receiver, obj_3.timeOffsetIterator, obj_3.withThreads)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutReadMessagesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "readMessageUpdates": {
                var obj_4 = new InReadMessageUpdates(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.readMessageUpdates(context, obj_4.receiver, obj_4.timeOffsetIterator)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutReadMessageUpdatesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteMessage": {
                var obj_5 = new InDeleteMessage(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteMessage(context, obj_5.message)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteMessageHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteMessages": {
                var obj_6 = new InDeleteMessages(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteMessages(context, obj_6.receiver, obj_6.from_, obj_6.till)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteMessagesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "sendToThread": {
                var obj_7 = new InSendToThread(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.sendToThread(context, obj_7.parent, obj_7.msgData)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSendToThreadHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "sendToThreadFrom": {
                var obj_8 = new InSendToThreadFrom(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.sendToThreadFrom(context, obj_8.parent, obj_8.msgData, obj_8.sender)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutSendToThreadFromHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "readThread": {
                var obj_9 = new InReadThread(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.readThread(context, obj_9.parent)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutReadThreadHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "readThreadBatch": {
                var obj_10 = new InReadThreadBatch(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.readThreadBatch(context, obj_10.parents)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutReadThreadBatchHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "readThreadMessages": {
                var obj_11 = new InReadThreadMessages(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.readThreadMessages(context, obj_11.receiver, obj_11.timeOffsetIterator)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutReadThreadMessagesHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteThreadMessage": {
                var obj_12 = new InDeleteThreadMessage(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteThreadMessage(context, obj_12.parent, obj_12.sender, obj_12.messageId)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteThreadMessageHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "availableChannels": {
                var obj_13 = new InAvailableChannels(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.availableChannels(context, obj_13.teamId)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutAvailableChannelsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "createChannel": {
                var obj_14 = new InCreateChannel(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.createChannel(context, obj_14.teamId, obj_14.teamChannel)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCreateChannelHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteChannel": {
                var obj_15 = new InDeleteChannel(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteChannel(context, obj_15.teamId, obj_15.teamChannel)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteChannelHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "pinMessage": {
                var obj_16 = new InPinMessage(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.pinMessage(context, obj_16.message)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutPinMessageHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "unpinMessage": {
                var obj_17 = new InUnpinMessage(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.unpinMessage(context, obj_17.message)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUnpinMessageHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by ProtectedTeamChatServiceDispatcher."));
        }
    };
    ProtectedTeamChatServiceDispatcher.methods = [
        "sendMessage",
        "sendMessageFrom",
        "readMessages",
        "readMessageUpdates",
        "deleteMessage",
        "deleteMessages",
        "sendToThread",
        "sendToThreadFrom",
        "readThread",
        "readThreadBatch",
        "readThreadMessages",
        "deleteThreadMessage",
        "availableChannels",
        "createChannel",
        "deleteChannel",
        "pinMessage",
        "unpinMessage"
    ];
    return ProtectedTeamChatServiceDispatcher;
}());
exports.ProtectedTeamChatServiceDispatcher = ProtectedTeamChatServiceDispatcher;
var ProtectedTeamChatServiceServer = (function (_super) {
    __extends(ProtectedTeamChatServiceServer, _super);
    function ProtectedTeamChatServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    ProtectedTeamChatServiceServer.prototype.sendMessage = function (context, message) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.sendMessageFrom = function (context, message, sender) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.readMessages = function (context, receiver, timeOffsetIterator, withThreads) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.readMessageUpdates = function (context, receiver, timeOffsetIterator) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.deleteMessage = function (context, message) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.deleteMessages = function (context, receiver, from_, till) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.sendToThread = function (context, parent, msgData) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.sendToThreadFrom = function (context, parent, msgData, sender) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.readThread = function (context, parent) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.readThreadBatch = function (context, parents) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.readThreadMessages = function (context, receiver, timeOffsetIterator) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.deleteThreadMessage = function (context, parent, sender, messageId) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.availableChannels = function (context, teamId) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.createChannel = function (context, teamId, teamChannel) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.deleteChannel = function (context, teamId, teamChannel) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.pinMessage = function (context, message) {
        throw new Error('Not implemented.');
    };
    ProtectedTeamChatServiceServer.prototype.unpinMessage = function (context, message) {
        throw new Error('Not implemented.');
    };
    return ProtectedTeamChatServiceServer;
}(ProtectedTeamChatServiceDispatcher));
exports.ProtectedTeamChatServiceServer = ProtectedTeamChatServiceServer;
//# sourceMappingURL=ProtectedTeamChatService.js.map